import { render, staticRenderFns } from "./FormSocialProfileQuestion.vue?vue&type=template&id=ba7a15c6"
import script from "./FormSocialProfileQuestion.vue?vue&type=script&lang=js"
export * from "./FormSocialProfileQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports